import { Component,OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'account-sold-to-detail',
  templateUrl: './sold-to-detail.component.html',
  styleUrls: ['./sold-to-detail.component.less']
})
export class MyAccountSoldToDetail implements OnInit {
  customerData: any = {};
  billList: any [] = [];
  payerList: any [] = [];
  shipList: any [] = [];
 
  constructor(
    private loginService:LoginService,
    private route: ActivatedRoute,
    private  cartService:CartService
  ) {

  }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.customerData = {
        customerCode: params?.customerCode,
        ch3Name: params?.ch3Name, 
        soldToNo: params?.soldToNo,
        soldToName: params?.soldToName,
        salesArea: params?.salesArea
      }
      if(params?.customerCode){
        this.getBillPayerShipList(params?.customerCode);
        this.loadCartList();
      }
    });

  }

  loadCartList(){
    let customer = JSON.parse(localStorage.getItem('customer') || '{}');
    let userData = JSON.parse(localStorage.getItem('userData') || '{}');
    if (userData?.queryUserPageInfoResDTO?.status === 2 && customer?.customerCode && location.pathname.includes(customer?.country)) {
      this.cartService.getListFromCart("create_time","desc");
    }
  }

 
  // get sold to list 
  getBillPayerShipList(customerCode: string): void {
    let params = {  
      customerCode: customerCode
    };
    this.loginService.getBillPayerShipList(params).subscribe(res => {
      const data = res.data
      this.billList = data?.billList || []
      this.payerList = data?.payerList || []
      const shipList = data?.shipList || []
      this.shipList = shipList.map((item: any)=>{
        if(shipList.some((v: any)=> !!v.userDefault)){
          return {
            ...item
          }
        }else{
          // 如果
          return {
            ...item,
            userDefault: item.customerDefault
          }
        }
      })
    })
  }

  handleSetDefault($event: any, shipCode: string){
    let params = {  
      customerCode: this.customerData.customerCode,
      shipCode,
      status: $event ? 1: 0
    };
    this.loginService.getshipAsDefault(params).subscribe(res => {
      if(res.code === 200){
        this.getBillPayerShipList(this.customerData.customerCode)
      }
    })
  }
  
}
